import PageLayout from 'pages/ViewQuizSubmission/PageLayout';
import PageProvider from 'pages/ViewQuizSubmission/PageProvider';

const ViewQuizSubmissionPage = () => (
    <PageProvider>
        <PageLayout />
    </PageProvider>
);

export default ViewQuizSubmissionPage;
